var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5068 32.5H1.49316C0.991093 32.5 0.584106 32.0831 0.584106 31.5686V1.43141C0.584106 0.917007 0.991093 0.5 1.49316 0.5C1.99521 0.5 2.40221 0.917007 2.40221 1.43141V30.6371H32.5068C33.0088 30.6371 33.4159 31.0542 33.4159 31.5685C33.4159 32.0829 33.0089 32.5 32.5068 32.5Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.899 7.57365L20.6602 10.8922H13.5269C13.0804 10.8922 12.6522 11.0739 12.3365 11.3974L4.56742 19.3575C4.27294 19.6593 4.27294 20.1483 4.56742 20.4501L5.88176 21.7967C6.17626 22.0985 6.65373 22.0985 6.94823 21.7967L14.2242 14.3419H21.3575C21.804 14.3419 22.2322 14.1602 22.5478 13.8367L27.9276 8.32466L29.3531 9.78191C29.6455 10.0809 30.1456 9.88919 30.1748 9.46691L30.5607 3.85352C30.5894 3.43726 30.2513 3.0916 29.845 3.12186L24.3672 3.52944C23.9551 3.5601 23.769 4.07295 24.0616 4.37199L25.5444 5.88804",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6789 28.6651C17.6789 28.6651 14.1912 28.7065 13.1992 25.9431C12.2162 23.2047 13.533 21.0765 13.533 21.0765C13.533 21.0765 14.2164 22.342 15.6408 21.6263C16.8699 21.0087 16.3506 18.392 15.6644 16.6774C15.6644 16.6774 19.0104 17.2343 19.9051 20.7446L21.0639 20.1742C21.0639 20.1742 22.4182 23.0562 21.6791 25.7506C21.4203 26.694 20.2055 28.6786 17.6789 28.6651Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32532 30.636V22.0224",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2179 30.6368V18.509",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1106 21.6554V14.6839",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1106 30.637V27.3503",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0161 17.7812V14.3421",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0161 30.6356V28.6538",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9088 30.6368V14.2494",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8014 30.636V10.5081",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.694 26.0124V9.97763",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.694 30.6366V28.3868",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85095 8.28601V9.97615",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68034 9.1306H8.03076",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrending);
export default __webpack_public_path__ + "static/media/trending.a781139d3700a6487752ad5aa76243a9.svg";
export { ForwardRef as ReactComponent };